import * as React from 'react';

import { cn } from '@/lib/utils';

// override (DocuShare reskin): a kártya-felület GLASS (card-glass = tömör felület + halvány zöld-tónusú
// border + finom NEUTRÁLIS content-lift, téma-tudatosan). A card-glass adja a hátteret ÉS a keretet, ezért a `bg-card`
// + `border` utility-ket elhagyjuk. Rádiusz marad 10px (Atlas-sűrűség).
const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('card-glass text-card-foreground overflow-hidden rounded-xl', className)}
      {...props}
    />
  ),
);
Card.displayName = 'Card';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center justify-between gap-2 border-b px-4 py-3.5', className)}
      {...props}
    />
  ),
);
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      // A SORMAGASSÁG NEM `leading-none`: az pontosan a betűtestre húzza a sor-boxot, és mivel a
      // kártya-fejléc címe `truncate`-elt (`overflow: hidden`) egy `overflow-hidden` kártyában, a magyar
      // szövegek ALSÓ SZÁRAI (g, j, gy, ty) levágásra kerültek — a user mérte a felületen.
      // A `leading-[1.35]` befogja a leszárakat, és a fejléc-magasságot alig (~2 px) mozdítja.
      className={cn('text-base font-semibold leading-[1.35] tracking-[-0.005em]', className)}
      {...props}
    />
  ),
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-muted-foreground text-sm', className)} {...props} />
  ),
);
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('p-4', className)} {...props} />,
);
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('bg-muted/50 flex items-center border-t px-4 py-3', className)}
      {...props}
    />
  ),
);
CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
